const API_ROOT = process.env.REACT_APP_API_URL;
if (!API_ROOT) throw new Error('REACT_APP_API_URL environment variable is required');

async function fetchWithRetry(fetchFn, { signal, maxRetries = 2, retryDelay = 3000, onRetry } = {}) {
	for (let attempt = 0; attempt <= maxRetries; attempt++) {
		if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
		try {
			return await fetchFn(signal);
		} catch (err) {
			if (err.name === 'AbortError') throw err;
			const isRetryable = err instanceof TypeError || (err.status >= 500);
			if (!isRetryable || attempt === maxRetries) throw err;
			onRetry?.(attempt + 1, maxRetries);
			await new Promise((resolve, reject) => {
				const timer = setTimeout(resolve, retryDelay);
				signal?.addEventListener('abort', () => { clearTimeout(timer); reject(new DOMException('Aborted', 'AbortError')); }, { once: true });
			});
		}
	}
}

export async function getGameTypes(signal, { onRetry } = {}) {
	return fetchWithRetry(async (sig) => {
		const response = await fetch(`${API_ROOT}/game/types/today`, { signal: sig });
		const data = await response.json();
		if (!response.ok) {
			const err = new Error(data.detail || 'Could not fetch game types.');
			err.status = response.status;
			throw err;
		}
		return Array.isArray(data) ? data : [data];
	}, { signal, onRetry });
}

export async function getGame(gameTypeSlug = 'classic', signal, { onRetry } = {}) {
	const url = `${API_ROOT}/game/today?game_type=${encodeURIComponent(gameTypeSlug)}`;
	return fetchWithRetry(async (sig) => {
		const response = await fetch(url, { signal: sig });
		const data = await response.json();
		if (!response.ok) {
			const err = new Error(data.detail || 'Could not fetch game.');
			err.status = response.status;
			throw err;
		}
		return data;
	}, { signal, onRetry });
}
